import { Tab, Tooltip } from 'bootstrap';
import throttle from "lodash.throttle";

jQuery(document).ready(function( $ ) {
    /*==================================================================
    ▐	BOTH PAGES
    ===================================================================*/
    if ( typeof yadroSocBothPages !== 'undefined' ) {
        // match media functionality
        let socDekstopResMatchMedia  = window.matchMedia( '(min-width: 1200px)' ),
            socDekstopResMode = socDekstopResMatchMedia.matches;
        socDekstopResMatchMedia.addEventListener( 'change', event => {
            socDekstopResMode = event.matches;
            // document.dispatchEvent( new CustomEvent( 'socDekstopResChange' ) );
        } );

        $( document ).on( 'click', 'a', function( event ) {
            $( this ).off();
            if (this.hash) {
                $( 'html, body' ).animate( {
                    scrollTop: $( this.hash ).offset().top + (socDekstopResMode ? -110 : -90),
                }, 500 );
                $( '.soc-close' ).click();
            } // IF
        } );

        if ($('.wpcf7-select').length) {
            const $rtl = $('.wpcf7-select option[value="RTL проектирование"]');
            if ($rtl) {
                $rtl.attr('disabled', true);
                $('.menu-439').attr('title', 'Уважаемый участник, число заявок от на трек RTL проектирования достигло максимума, поэтому мы закрыли его для новых регистраций. Однако можно попробовать свои силы в двух других треках нашего соревнования.');
                const rt = new Tooltip($('.menu-439'), {
                    customClass: 'expert-tooltip',
                    placement: 'top',
                });
            }
        }
    } // IF | both pages

    /*==================================================================
    ▐	CHALLENGE PAGE
    ===================================================================*/
    if ( typeof yadroSocChallengePage !== 'undefined' ) {

        // tooltip
        if (document.querySelector('.expert-block')) {
            var exampleEl = document.querySelectorAll('.expert-block');
            exampleEl.forEach(el => {
                const t = new Tooltip(el, {
                    customClass: 'expert-tooltip',
                    placement: 'top',
                });
            });
        }

        if ($(window).width() < 1100) {
            $('.soc-tracks-nav .nav-item').hide();
            $('.soc-tracks-nav .active').parent().css('display', 'flex');
            // $('.socTracks .active').parent().css({ 'height': '210px' });
            $('.js-nav-link-next').on( 'click', function() {
                var $this = $(this);
                var $nav = $this.closest('ul');
                var $tabs = $nav.find('button');
                var $curTab = $tabs.filter('.active');
                var cur = $tabs.index($curTab);
                let $showTab = cur === $tabs.length - 1 ? $tabs.eq(0) : $tabs.eq(cur + 1);
                var tabTrigger = new Tab($showTab);
                tabTrigger.show();
                $('.soc-tracks-nav .nav-item').hide();
                $('.soc-tracks-nav .active').parent().css({
                    'display': 'flex',
                });
            });

            $('.js-nav-link-rtl').on( 'click', function (event) {
                event.preventDefault();
                var $showTab = $('#pills-rtl-tab');
                var tabTrigger = new Tab($showTab);
                tabTrigger.show();
                $('.soc-tracks-nav .nav-item').hide();
                $('.soc-tracks-nav .active').parent().css({
                    'display': 'flex',
                });
            });
        } else {
            $('.js-nav-link-rtl').on( 'click', function (event) {
                event.preventDefault();
                $('#pills-rtl-tab').click();
            });
        }

    } // challenge page


    /*==================================================================
    ▐	RESULTS PAGE
    ===================================================================*/
    if (
        typeof yadroSocResultsPage !== 'undefined'
        || typeof yadroSocChallengePage !== 'undefined'
    ) {

        /*  Photo Slider
        -------------------------------------------------------------------*/
        const photoSlider = $('#photos__slider'),
              // arrowHTML = '<svg width="30" height="31" class="svg-icon pe-none"><use xlink:href="#soc__icon-next"/></svg>',
              owlOptions = {
                loop:      false,
                margin:    20,
                // autoWidth: true,
                // nav:       true,
                dots:      true,
                // navContainerClass: 'owl-nav container-xl position-absolute top-50 translate-middle-y px-0 mt-md-0 d-flex justify-content-between pe-none',
                dotsClass: 'owl-dots container-md d-sm-flex position-absolute',
                // navText: [arrowHTML, arrowHTML],
                responsive: {
                    0: {
                        items: 1,
                        slideBy: 1,
                        margin: 6,
                    },
                    600:    {
                        items: 2,
                        slideBy: 1,
                    },
                    1000: {
                        items: 3,
                        slideBy: 3,
                    },
                    1400: {
                        items: 4,
                        slideBy: 4,
                    },
                }
              }

        photoSlider.owlCarousel(owlOptions);

        /*  Fancybox (lightbox) for the Photo slider
        -------------------------------------------------------------------*/
        photoSlider.find( '[data-fancybox="photo-gallery"]' ).fancybox( {
            // Try to focus on the first focusable element after opening (if set to true)
            autoFocus: false,

            // Put focus back to active element after closing (if set to true)
            backFocus: false,
        } );

            var owlsToHandle = $('.winners__slider');

        let owlSmallOptions = {
            // margin:       10,
            loop:         true,
            autoWidth:    false,
            stagePadding: 0,
            items:        1,
            nav:          false,
            dots:         true,
            dotsClass:    'owl-dots container-md d-sm-flex position-absolute',
          }

        if ( $(window).width() < 768 ) {
            owlsToHandle.owlCarousel(owlSmallOptions);
            owlsToHandle.removeClass('off');
            owlsToHandle.addClass('owl-carousel owl-theme');
        } else {
            owlsToHandle.addClass('off');
            owlsToHandle.removeClass('owl-carousel owl-theme');
        }

        $(window).resize(function() {
            var owlsToHandle = $('.winners__slider');
            if ( $(window).width() < 768 ) {
                if ( owlsToHandle.hasClass('off') ) {
                    owl.owlCarousel(owlSmallOptions);
                    owlsToHandle.removeClass('off');
                    owlsToHandle.addClass('owl-carousel owl-theme');
                }
            } else {
                if ( !owlsToHandle.hasClass('off') ) {
                    owlsToHandle.addClass('off').trigger('destroy.owl.carousel');
                    owlsToHandle.removeClass('owl-carousel owl-theme');
                    owlsToHandle.find('.owl-stage-outer').children(':eq(0)').unwrap();
                }
            }
        });

    } // if Results page
});

function toggleHeader() {
    if ( window.scrollY > 10 ) {
        document.body.classList.add( 'scrolled' );
    } else {
        document.body.classList.remove( 'scrolled' );
    }
}

document.addEventListener( 'scroll', throttle( () => {
    toggleHeader();
}, 10 ) );